import React from "react";
import styled from "styled-components";
import { EyeIcon, PencilIcon } from "./assets";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "./utils";
const Card = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: "Arial", sans-serif;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
`;

const Label = styled.span`
  color: var(--Color-Text-Gray, #64748b);
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.14px;
`;

const Value = styled.span`
  color: var(--Color-Brand-Primary, #212543);
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 22.4px */
  letter-spacing: -0.14px;
  max-width: 50%; /* Enable wrapping */
  word-break: break-word;
  white-space: normal;
  text-align: right;
`;


const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e1e4ea;
  margin: 6px 0;
`;

const ActionIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #666;
  cursor: pointer;
  font-size: 18px;
`;
const STATUS_COLORS = {
  won: "rgba(18, 124, 78, 0.1)",
  "verbally committed": "rgba(244, 186, 52, 0.1)",
  "proposal sent": "rgba(244, 186, 52, 0.1)",
  lost: "rgba(240, 70, 63, 0.1)",
  "lead identified": "rgba(89, 84, 222, 0.1)",
  opportunity: "rgba(89, 84, 222, 0.1)",
};

const StatusTag = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  align-self: stretch;
  background: ${(props) => {
    const normalizedStatus = props.status?.toLowerCase?.();
    const color = STATUS_COLORS[normalizedStatus];
    return color
      ? `linear-gradient(-90deg, ${color}, ${color})`
      : "transparent";
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 4px 8px;
  flex-shrink: 0;
`;

const StatusText = styled.span`
  color: ${(props) => {
    const normalizedStatus = props.status?.toLowerCase?.();

    switch (normalizedStatus) {
      case "lead identified":
        return "rgba(89, 84, 222, 1)";
      case "proposal sent":
      case "verbally committed":
        return "rgba(244, 186, 52, 1)";
      case "lost":
        return "rgb(240, 70, 63)";
      case "won":
        return "rgba(18, 124, 78, 1)";
      default:
        return "inherit";
    }
  }};
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;
function ReferralCard({ item, handleEditClick }) {

  const status = item?.referral_status.toLowerCase();
  const isEditable = status !== "Lost" && status !== "Won";
  const navigate = useNavigate();

  const handleRowClick = (item) => {
    navigate(`/referral/${item._id}`);
    scrollToTop();
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };



  
  return (
    <Card>
      <Row>
        <Label>Referral ID</Label>
        <Value>{item.referrer_id}</Value>
      </Row>
      <Row>
        <Label>Referrer Name</Label>
        <Value>{item?.memberName}</Value>
      </Row>
      <Row>
        <Label>Potential Client's Website</Label>
        <Value>{item?.company_website_url}</Value>
      </Row>
      <Row>
        <Label>Expected Close Date</Label>

        <Value>{item?.expected_close_date ? formatDate(item.expected_close_date) : "-"}</Value>
      </Row>

      <Row>
        <Label>Status</Label>
        <div style={{ display: "flex", gap: "12px" }}>
          <StatusTag status={status}>
            <StatusText status={status}>{item.referral_status}</StatusText>
          </StatusTag>
          {isEditable && (
            <>
              <img
                src={PencilIcon}
                alt="Edit"
                style={{ cursor: "pointer", width: 14 }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row click
                  handleEditClick(item);
                  
                }}
              />
            </>
          )}
        </div>
      </Row>
      <Divider />
      <Row>
        <Label>Actions</Label>
        <ActionIcon
          onClick={(e) => {
            e.stopPropagation(); // Prevent row click
            handleRowClick(item);
          }}
        >
          <img src={EyeIcon} alt="Eye" size={20} />
        </ActionIcon>
      </Row>
    </Card>
  );
}

export default ReferralCard;
